import { Align } from "../../../../common/TextUtils"
import { ButtonContainer, Buttons, ButtonSize, ButtonType } from "../../../generic-sprites/Buttons"

export class WheelOfMisfortuneButton {
    button: ButtonContainer

    constructor(game: Phaser.Game, text: string, group: Phaser.Group, x: number, y: number, onClick: (() => void | undefined) = undefined) {
        this.button = Buttons.create(game, text, onClick, {
                x,
                y,
                scale: 1,
                group,
                buttonSize: ButtonSize.WIDE,
                buttonType: ButtonType.PRIMARY,
                textConfig: {weight: "bold", align: Align.CENTER},
                enabled: true
            })
    }

    setText = (text: string) => {
        this.button.text.setText(text)
        this.button.center()
    }

    removeEvents = () => this.button.button.events.onInputDown.removeAll()

    setOnClick = (onClick: () => void) => this.button.setOnClick(onClick)

    setOnClickOnce = (onClick: () => void) => this.button.setOnClickOnce(onClick)

    enable = () => this.button.enable()

    disable = () => this.button.disable()
}